import { createAction } from '@reduxjs/toolkit'

export const idleCheck = createAction<boolean>('commonTypes/idleCheck')
export const loggedOut = createAction('commonTypes/loggedOut')
export const connectionIssue = createAction<unknown>('commonTypes/connectionIssue')
export const searchCategoryChange = createAction('commonTypes/searchCategoryChange')
export const internalServerError = createAction('commonTypes/internalServerError')
export const serviceUnavailableError = createAction('commonTypes/serviceUnavailableError')
